// Canales de contacto del negocio, en UN solo lugar.
// Números y redes oficiales de Exygen Labs (Christian, 2026-07-23).
export const WHATSAPP_URL = 'https://wa.me/529999041307';
export const WHATSAPP_DISPLAY = '+52 (999) 904-1307';
// El nombre de usuario de WhatsApp, que es lo que Christian reparte (2026-07-28).
// Se enseña en el pie debajo del correo; el enlace sigue siendo el wa.me del número,
// que es el que abre la conversación en cualquier teléfono.
export const WHATSAPP_HANDLE = '@exygenlabs';
export const CONTACT_EMAIL = 'hola@exygenlabs.com';

export const INSTAGRAM_URL = 'https://www.instagram.com/exygenlabs';
export const FACEBOOK_URL = 'https://www.facebook.com/share/1DKMAdb3eE/';
